import { ReactNode, useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '../stores/auth';
import { api } from '../api/client';

/**
 * 鉴权壳：无 token 跳登录；有 token 时顺便拉一次 /auth/me 刷新用户信息。
 */
export default function RequireAuth({ children }: { children: ReactNode }) {
  const { accessToken, user, setUser, logout } = useAuthStore();
  const location = useLocation();

  useEffect(() => {
    if (!accessToken) return;
    api
      .get('/auth/me')
      .then((resp) => setUser(resp.data))
      .catch(() => logout());
  }, [accessToken, setUser, logout]);

  if (!accessToken) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  // 首次登录强制改密码的弹窗后续再加，这里先放行
  if (!user) {
    return null; // 或一个 loading spinner
  }

  return <>{children}</>;
}
